import React from 'react';
import DivSX, { DivSXProps } from 'tradevan-ui/@emotion/DivSX';
import { classCombine } from 'tradevan-ui/consts';

interface TbSingleRwdThProps extends DivSXProps {
  hdFixed?: boolean;
}

const TbSingleRwdTh = (props: TbSingleRwdThProps): JSX.Element => {
  const { className, children, hdFixed, ...other } = props;
  return (
    <DivSX
      className={classCombine(`td hd`, hdFixed && 'hd-fixed', className)}
      {...other}
    >
      {children}
    </DivSX>
  );
};

export default TbSingleRwdTh;
